import styled from 'styled-components';

export const PhoneVideoContainer = styled.div`
    opacity: 1;
    grid-area: home-phone;
    position: relative;
    justify-self: center;
    align-self: center;
    width: 100%;
    filter: drop-shadow(rgba(0, 39, 74, 0.3) 8px 8px 67px);

    & > .gatsby-image-wrapper {
      position: relative;
      z-index: 2;
    }

    @media all and (max-width: 760px) {
      width: 380px;
      max-width: 70vw;
    }

`

export const PhoneVideoPosition = styled.div`
  max-width: 90%;
  position: absolute;
  bottom: 2%;
  left: 5%;
  margin: 0 auto;

  & > .gatsby-image-wrapper {
    position: relative;
    z-index: 2;
  }

  & > video {
    position: absolute;
    z-index: 2;
    left: 0px;
    top: 0px;
  }
`;
